import React, {useContext, useEffect, useState} from "react";
import apiRequest from "../../services/apiRequest";
import {NotificationsContext} from "../../ui-components/Notifications";
import {FormattedMessage, useIntl} from "react-intl";
import Modal from "../../ui-components/Modal";
import SearchSelect from "../../ui-components/SearchSelect";
import _ from "lodash";
import Button from "../../ui-components/Button";
import CountryContext from "../../CountryContext";

const WorksiteReferenceReportModal = ({
    isOpen,
    onDismiss,
    onConfirm,
    showFieldsSelector
}) => {

  const intl = useIntl();

  // context
  const { push } = useContext(NotificationsContext);
  const { country: { code } } = useContext(CountryContext);

  // state
  const [fields, setFields] = useState();
  const [selectedField, setSelectedField] = useState();

  // utilities
  const fieldsOptions = _.orderBy(
    fields?.map(({id, firstname, lastname}) => ({value: id, label: `${lastname} ${firstname}`})) ?? [],
    ['label'],
    ['asc']
  );

  useEffect(
    () => {
      if (!showFieldsSelector)
        return;

      apiRequest.post(
          '/users/with_role',
          {role: ['field'], country: code, active_only: true }
        )
        .then(setFields)
        .catch((err) => {
          push({type:"error", title: intl.formatMessage({id: "an_error_occurred"})});
          throw err;
        })
    },
    []  // eslint-disable-line react-hooks/exhaustive-deps
  )

  return <Modal
    opened={isOpen}
    onExit={onDismiss}
    overflowCls=""
  >
    <h1 className="text-xl text-center mb-2">
      <FormattedMessage id="confirm_report_reference" />
    </h1>
    <p className="text-sm my-4">
      <FormattedMessage id="confirm_report_reference_description" />
    </p>
    {showFieldsSelector && (
      <SearchSelect
        label={intl.formatMessage({id: "kerakoll_fields"})}
        options={fieldsOptions}
        value={selectedField}
        onChange={setSelectedField}
        loadOptions={false}
        isMulti={false}
        isDisabled={showFieldsSelector && !fields}
      />
    )}
    <div className="flex flex-col sm:flex-row gap-x-2 gap-y-1 mt-4">
      <div className="flex-1 sm:order-last">
        <Button
          full
          onClick={() => { onConfirm(selectedField?.value); }}
          disabled={showFieldsSelector && !selectedField}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </div>
      <div className="flex-1">
        <Button
          full
          styleType="empty"
          onClick={onDismiss}
        >
          <FormattedMessage id="cancel" />
        </Button>
      </div>
    </div>
  </Modal>
}

export default WorksiteReferenceReportModal;